  import Router from 'vue-router'
  import Vue from 'vue'
  import web from './web'
  import empresa from './empresa'
  import credenciada from './credenciada'
  import parceiro from './parceiro'

  var 
    hostname = window.location.hostname ,
    urlParams = null, 
    ambiente = null,
    routes = [];

  console.log('**hostname ' + hostname+'**');
  

  if(process.env.NODE_ENV == 'development'){
    urlParams = new URLSearchParams(window.location.search);
    ambiente = urlParams.get('t');

    if(ambiente == 'emp')
    {
      routes = empresa;
      
    } 
    else if(ambiente == 'cre')
    {
      routes = credenciada;
    } 
    else
    {
      routes = web;
    } 
    
  }
  else{
    if(hostname == process.env.URL_API.web) {
      routes = web;
    }
    else if (hostname == process.env.URL_API.empresa) {
      routes = empresa;
    }
    else if (hostname == process.env.URL_API.credenciada) {
      routes = credenciada;
    }
    else if (hostname == process.env.URL_API.parceiro) {
      routes = parceiro;
    }
    else {
      routes = web;
    }
  }
 
  Vue.use(Router)

  export default new Router({
    history: true,
    mode: 'history',
    routes: routes
  });



// WEBPACK FOOTER //
// ./src/router/index.js